<template>
    <div class="card">
        <div class="card-content">
            <p v-html="labelText"></p>

            <div class="has-text-centered send-link-button-container">
                <a :href="action" class="button is-link">{{ trans.continue }}</a>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "AcceptUserPolicy",
    props: {
        trans: {
            type: Object,
            default: () => {}
        },
        action: {
            type: String,
            default: '',
        }
    },
    methods: {
        replaceLink(text, link) {
            return text.replace(':link', link);
        },
    },
    computed: {
        labelText() {
            let license = this.replaceLink(this.trans.confirm_licence, agreements.agreement),
            personal = this.replaceLink(this.trans.confirm_personal_data, agreements.agreement_pers);

            return `${license} ${personal}`;
        }
    }
}
</script>